import React from 'react';

export const FilesManagementModalContext = React.createContext({
  selectedImageSource: '',
  setSelectedImageSource: () => undefined,
  uploadInput: null,
});
export const FilesManagementModalProvider = FilesManagementModalContext.Provider;
